<template>
  <div class="mb-12 text-center">
    <h1 class="mb-4 text-4xl font-bold text-ternary-dark dark:text-primary-light sm:text-5xl">
      {{ title }}
    </h1>
    <p class="text-xl text-gray-600 dark:text-gray-400">
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  description: string
}

defineProps<Props>()
</script>
